const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'projectTerms',
        // updateTabTitleForFieldCodes: {
        //     title: true,
        //     startTS: true,
        // },
        // // updateTabTitleControllerLocator: '< base_tabStrip_tabStrip > templates_customers_projectTerms_controller',
        grantedMinorChangesForFieldCodes: {
            contactName: 	true,
            contactMobile: 	true,
            infoByCustomer: true,
            catering: true,
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_projectTerms': true,
        },
    },

    model: {
        projectMeta: {}, // @see MARK: CUSTOMER_PROJECT_META_LOADER
    },

    methods: {

        // which properties is a customer allowed to change?
        onProjectMetaChanged(meta, nextMeta){
            if(
                this.config.isReady
                &&
                !this.config.creationMode
                &&
                (!meta.hash || meta.hash !== nextMeta.hash)
            ){
                this.refresh(false)
            }
        },

        // which properties is a customer allowed to change?
        onBeforeRender(){
            if(!this.config.creationMode){
                if(utils.isEmpty(this.model.projectMeta)){
                    this.locate('< templates_customers_projectTerms_controller', controller => {
                        this.model.projectMeta = {
                            ...(controller.model.projectMeta || {})
                        }
                    })
                }

                // disable fields on non drafters
                const projectTermID = ((this.resourceData.data || {}).attributes || {}).projectTermID
                let grantedChanges = ((this.model.projectMeta || {}).grantedChanges || {}).project || {}
                if(projectTermID){
                    grantedChanges = (((this.model.projectMeta || {}).grantedChanges || {}).projectTerms || {})[projectTermID] || {}
                }

                for(const fieldCode in this.model.namedFields){
                    const field = this.model.namedFields[fieldCode] || {}
                    field.config = field.config || {}

                    if(field.config.disabledBackup === undefined && field.config.disabled !== undefined){
                        field.config.disabledBackup = !!field.config.disabled
                    }

                    if(grantedChanges.major || grantedChanges.minor && this.config.grantedMinorChangesForFieldCodes[fieldCode]){
                        field.config.disabled = !!field.config.disabledBackup
                    } else {
                        field.config.disabled = true
                    }
                }
            }
        },
    },

    hooks: {
        // which properties is a customer allowed to change?
        projectMetaChanged($element, options){
            const meta = { ...(this.model.projectMeta || {}) }
            const nextMeta = this.model.projectMeta = (options || {}).projectMeta || {}
            this.onProjectMetaChanged(meta, nextMeta)
        },
    },
}